const { VUE_APP_CODE, VUE_APP_API_BASE_URL, VUE_APP_API_AUTH_URL, VUE_APP_API_DL_URL, VUE_APP_API_PE_URL, VUE_APP_API_DL_AUTH_TOKEN, VUE_APP_API_PE_AUTH_TOKEN, VUE_APP_ENV_MODE, NODE_ENV = '' } = process.env;

const environment = NODE_ENV.toLowerCase();
const appCode = VUE_APP_CODE;
const apiBaseUrl = VUE_APP_API_BASE_URL;
const apiAuthUrl = VUE_APP_API_AUTH_URL;
const apiDlUrl = VUE_APP_API_DL_URL;
const apiPeUrl = VUE_APP_API_PE_URL;
const dlAuthToken = VUE_APP_API_DL_AUTH_TOKEN;
const peAuthToken = VUE_APP_API_PE_AUTH_TOKEN;
const envMode = VUE_APP_ENV_MODE;

export { environment, appCode, apiBaseUrl, apiAuthUrl, apiDlUrl, apiPeUrl, dlAuthToken, peAuthToken, envMode };
